// TODO: make this the main file when we move checkout to NextJS

import Button from "@ui-kit/form/Button/Button.web";
import Box from "@ui-kit/layout/Box/Box.web";
import Text from "@ui-kit/typography/Text/Text.web";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import CartSummary from "@app-contexts/public/features/basket/components/cart-summary/CartSummary/CartSummary.web";
import CheckoutLabel from "@ui-application/data-display/CheckoutLabel/CheckoutLabel.web";
import useRedirect from "@shared/hooks/useRedirect";
import url from "@shared/utils/urls/url";
import { usePublicBasket } from "@app-contexts/public/features/basket/services/usePublicBasket";
import { useTranslation } from "@shared/utils/internationalization";
import { useCallback } from "react";
import { CartSummaryModalProps } from "./CartSummaryModal.props";

export default function CartSummaryModal({
  venue = undefined,
  isOpen,
  onClose,
  holdLink = undefined,
  dynamicHoldParams = undefined,
}: CartSummaryModalProps) {
  const { redirect } = useRedirect();
  const { t } = useTranslation("common");
  const { hasItems, isBasketUpdating, totalItemQuantity, isWaitlist } =
    usePublicBasket();

  // TODO: should use router.push() when everything is in NextJS
  const goToCheckout = useCallback(
    () => redirect(url("checkout"), { asWindow: true }),
    [redirect]
  );

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
      size="4xl"
      scrollBehavior="inside"
    >
      <Modal.Header>{t("Cart summary")}</Modal.Header>

      <Modal.Body>
        <Box fontSize="md" minHeight="element.7xl">
          {hasItems ? (
            <CartSummary
              isDrawer
              venue={venue}
              holdLink={holdLink}
              onCartClose={onClose}
              dynamicHoldParams={dynamicHoldParams}
            />
          ) : (
            <Text>{t("There are no items in your cart")}</Text>
          )}
        </Box>
      </Modal.Body>

      <Modal.Footer>
        <Button
          data-testid="cart-summary-modal-checkout"
          ml="auto"
          variant="solid"
          colorPalette="primary"
          minHeight="element.3xl"
          minWidth="element.8xl"
          onClick={goToCheckout}
          isLoading={isBasketUpdating}
          disabled={!hasItems || isBasketUpdating}
        >
          <CheckoutLabel
            totalItemQuantity={totalItemQuantity}
            isWaitlist={isWaitlist}
          />
        </Button>
        <Button.Ghost
          data-testid="cart-summary-modal-cancel"
          onClick={onClose}
          textDecoration="underline"
        >
          {t("Cancel", { ns: "common" })}
        </Button.Ghost>
      </Modal.Footer>
    </Modal>
  );
}
